<script>
import { mapMutations, mapState, mapGetters } from 'vuex'
import { required, requiredUnless, email, minLength, maxLength, numeric } from 'vuelidate/lib/validators'
import { driversLicense, USDLRegex, isDate } from 'src/utils/validators'
import SlDateTime from 'components/Shared/DatePicker'
import AwesomeMask from 'awesome-mask'
const moment = require('moment')

export default {
  name: 'StudentGeneral',
  data () {
    return {
      statusOptions: this.$store.state.shared.statuses,
      genderOptions: this.$store.state.shared.genders,
      moment: moment
    }
  },
  components: {
    SlDateTime
  },
  directives: {
    'mask': AwesomeMask
  },
  validations () {
    return {
      studentForm: {
        STUDENT_FIRST_NAME: { required },
        STUDENT_LAST_NAME: { required },
        STUDENT_EMAIL: { email },
        STUDENT_PHONE: { required },
        STUDENT_DOB: { required, isDate }
      },
      driversLicenseForm: {
        DRIVERS_LICENSE: { 
          required, 
          driversLicense: driversLicense('LK_STATE_ID')
        },
        LK_STATE_ID: { required }
      }
    }
  },
  mounted () {
  },
  computed: {
    validation () { 
      return this.$v 
    },
    driversLicenseError () {
      const errorMessage = (this.stateAbbrev) ? USDLRegex[this.stateAbbrev].description.join(', ') : ''
      return errorMessage
    },
    ...mapState({
      suffixOptions: state => state.shared.suffixes
    }),
    ...mapState('students', {
      studentForm: state => state.studentForm,
      driversLicenseForm: state => state.driversLicenseForm
    }),
    ...mapGetters([
      'stateOptions',
      'suffixOptions'
    ]),
    ...mapGetters('students', [
      'stateAbbrev'
    ]),
     selectedSuffix() {
      return this.suffixOptions[this.studentForm.STUDENT_SUFFIX - 1] ? this.suffixOptions[this.studentForm.STUDENT_SUFFIX - 1].label:"";
    }
  },
  methods: {
    driversLicenseValidation (value) {
      if(!value) return true
      const stateRegex = new RegExp(USDLRegex[this.stateAbbrev].rule)
      const valid = stateRegex.test(value)
      return valid
    },
    ...mapMutations('students', [
      'updateForm',
      'updateStudentForm',
      'updateAdministratorForm'
    ]),
    validateDate (date, required) {
        let formats = ['M-D-YYYY', 'M/D/YYYY','M.D.YYYY']
        let isValid = moment(date,formats,true).isValid()
        if (!isValid && !required && !date) {
            isValid = true
        }
        return (isValid) ? true : false
    },
  }
}
</script>

<template>
  <div class="layout-padding fit scroll">
    <div class="q-pb-xl">
      <!-- <div class="row justify-end">
        <q-field class="q-pa-md">
          <q-toggle 
            label="Active"
            v-model="studentForm.ACTIVE_IND"
            @input="updateForm({ form: 'studentForm', field: 'ACTIVE_IND', value: studentForm.ACTIVE_IND })"
          />
        </q-field>
      </div> -->
      <div class="q-pb-xl">
        <h5> Drivers License </h5>
        <div class="row">
          <q-field class="q-pa-md col-4">
            <q-select
              float-label="Drivers License State"
              :value="driversLicenseForm.LK_STATE_ID"
              :options="stateOptions"
              :after="[
                {icon: 'flag', condition: validation.driversLicenseForm.LK_STATE_ID.$invalid },
                {icon: 'fa fa-check', condition: !validation.driversLicenseForm.LK_STATE_ID.$invalid}
              ]"
              :disable="true"
            />
              <!--@blur="validation.driversLicenseForm.DRIVERS_LICENSE.$touch"
              @change="val => updateForm({ form: 'driversLicenseForm', field: 'LK_STATE_ID', value: val })"-->
          </q-field>
          <q-field class="q-pa-md col-4"
            :error="validation.driversLicenseForm.DRIVERS_LICENSE.$error"
            :error-label="driversLicenseError"
          >
            <q-input
              float-label="Drivers License Number"
              :disable="true || !driversLicenseForm.LK_STATE_ID"
              :value="driversLicenseForm.DRIVERS_LICENSE"
              :after="[
                {icon: 'flag', condition: validation.driversLicenseForm.LK_STATE_ID.$invalid },
                {icon: 'fa fa-check', condition: !validation.driversLicenseForm.LK_STATE_ID.$invalid}
              ]"
              required>
              <!--@blur="validation.driversLicenseForm.DRIVERS_LICENSE.$touch"
              @keyup.stop="updateForm({ form: 'driversLicenseForm', field: 'DRIVERS_LICENSE', value: $event.target.value.toUpperCase() })"-->
            </q-input>
          </q-field>
        </div>
      </div>
      <div class="q-pb-xl">
        <h5> Details </h5>
        <div class="row">
          <q-field class="q-pa-md col-4"
            :error="validation.studentForm.STUDENT_LAST_NAME.$error"
            error-label="Last name is required"
          >
            <q-input
              float-label="Last Name"
              :value="studentForm.STUDENT_LAST_NAME"
              :after="[
                {icon: 'flag', condition: validation.studentForm.STUDENT_LAST_NAME.$invalid },
                {icon: 'fa fa-check', condition: !validation.studentForm.STUDENT_LAST_NAME.$invalid}
              ]"
              :disable="true"
              required>
              <!--@blur="validation.studentForm.STUDENT_LAST_NAME.$touch"
              @keyup.stop="updateForm({ form: 'studentForm', field: 'STUDENT_LAST_NAME', value: $event.target.value })"-->
            </q-input>
          </q-field>
          <q-field 
            class="q-pa-md col-4"
            :error="validation.studentForm.STUDENT_FIRST_NAME.$error"
            error-label="First name is required"
          >
            <q-input
              float-label="First Name"
              :value="studentForm.STUDENT_FIRST_NAME"
              :after="[
                {icon: 'flag', condition: validation.studentForm.STUDENT_FIRST_NAME.$invalid },
                {icon: 'fa fa-check', condition: !validation.studentForm.STUDENT_FIRST_NAME.$invalid}
              ]"
              :disable="true"
              required>
              <!--@blur="validation.studentForm.STUDENT_FIRST_NAME.$touch"
              @keyup.stop="updateForm({ form: 'studentForm', field: 'STUDENT_FIRST_NAME', value: $event.target.value })"-->
            </q-input>
          </q-field>
          <q-field class="q-pa-md col-4">
            <q-input
              float-label="Middle Name"
              :value="studentForm.STUDENT_MIDDLE_NAME"
              :disable="true"
              required>
            </q-input>
              <!--@keyup.stop="updateForm({ form: 'studentForm', field: 'STUDENT_MIDDLE_NAME', value: $event.target.value })"-->
          </q-field>
        </div>
        <div class="row">
          <q-field class="q-pa-md col-4">
            <q-select
              float-label="Suffix"
              :value="studentForm.STUDENT_SUFFIX"
              :display-value="selectedSuffix"
              :options="suffixOptions"
              :disable="true"
            />
              <!--@change="val => updateForm({ form: 'studentForm', field: 'STUDENT_SUFFIX', value: val })"-->
          </q-field>
          <q-field class="q-pa-md col-4"
            :error="validation.studentForm.STUDENT_DOB.$error"
            error-label="Invalid Date">
            <sl-date-time
              :value="studentForm.STUDENT_DOB"
              float-label="Date of Birth"
              type="date" 
              width="100%"
              :disable="true"
              required
            />
              <!--@keyup.stop="updateForm({ form: 'studentForm', field: 'STUDENT_DOB', value: $event.target.value })"
              @blur="validation.studentForm.STUDENT_DOB.$touch" -->
          </q-field>
          <q-field class="q-pa-md col-4">
            <q-select
              float-label="Gender"
              :value="studentForm.STUDENT_GENDER"
              :options="genderOptions"
              :disable="true"
            />
            <!--  @change="val => updateForm({ form: 'studentForm', field: 'STUDENT_GENDER', value: val })"-->
          </q-field>
        </div>
        <div class="row">
          <q-field class="q-pa-md col-6"
            :error="validation.studentForm.STUDENT_EMAIL.$error"
            error-label="Must be a valid email"
          >
            <q-input
              float-label="Email"
              :value="studentForm.STUDENT_EMAIL"
              :disable="true"
              required><!--@blur="validation.studentForm.STUDENT_EMAIL.$touch"
              @keyup.stop="updateForm({ form: 'studentForm', field: 'STUDENT_EMAIL', value: $event.target.value })"-->
            </q-input>
          </q-field>
          <q-field 
            class="q-pa-md col-6"
            :error="validation.studentForm.STUDENT_PHONE.$error"
            error-label="Phone must be numeric"
          >
            <q-input
              float-label="Phone"
              type="tel"
              v-mask="'999-999-9999'"
              :value="studentForm.STUDENT_PHONE"
              :after="[
                {icon: 'flag', condition: validation.studentForm.STUDENT_PHONE.$invalid },
                {icon: 'fa fa-check', condition: !validation.studentForm.STUDENT_PHONE.$invalid}
              ]"
              :disable="true"
              required>
              <!--@blur="validation.studentForm.STUDENT_PHONE.$touch"
              @keyup.stop="updateForm({ form: 'studentForm', field: 'STUDENT_PHONE', value: $event.target.value })"-->
            </q-input>
          </q-field>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
</style>
